// The code in this file will load on every page of your site
import {session} from 'wix-storage';
import wixLocation from 'wix-location';
let previousPageURL;

$w.onReady(function () {
	previousPageURL = session.getItem("page");
	session.setItem("page", wixLocation.url);
	// Write your code here
});